import React, { ReactNode, forwardRef } from "react";
import styled from "@emotion/styled";

interface TextProps {
  size?: "small" | "medium" | "large" | string;
  textcolor?: "#6b7280" | "#444" | "#fff" | "#8B8D94" | "#FF0000" | "#4c515b" | string;
  fontweight?: string;
  fontWeight?: string;
  fontsize?: string | number;
  fontstyle?: string;
  whiteSpace?: string;
  color?: string;
  borderright?: string;
  style?: React.CSSProperties;
  children: ReactNode;
  onClick?: () => void;
  cursor?: "auto" | "pointer";
  margin?: string;
  marginTop?: string;
  padding?: string;
  letterspacing?: number;
  textalign?: string;
  alignitems?: string;
  aligncontent?: string;
  lineheight?: string;
  textdecorationline?: string;
  minwidth?: string;
  width?: string;
  className?: string;
}

const StyledText = styled.div<TextProps>`
  width: ${(props) => props.width};
  line-height: ${(props) => props.lineheight || "150%"};
  min-width: ${(props) => props.minwidth};
  align-content: ${(props) => props.aligncontent};
  text-align: ${(props) => props.textalign || "normal"};
  align-items: ${(props) => props.alignitems};
  letter-spacing: ${(props) => props.letterspacing || -0.34}px;
  margin: ${(props) => props.margin};
  margin-top: ${(props) => props.marginTop};
  padding: ${(props) => props.padding};
  cursor: ${(props) => props.cursor};
  color: ${(props) => props.textcolor || "#1F2024"};
  text-decoration-line: ${(props) => props.textdecorationline};
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
  box-sizing: border-box;
  font-size: ${(props) => {
    switch (props.size) {
      case "small":
        return "clamp(13px, 2vw, 14px)";
      case "large":
        return "clamp(20px, 3.5vw, 24px)";
      case "medium":
        return "clamp(15px, 2.5vw, 17px)";
      default:
        return `${props.size}`;
    }
  }};
  font-weight: ${(props) => props.fontweight || "normal"};
`;

const Text = forwardRef<HTMLDivElement, TextProps>((props, ref) => {
  return (
    <StyledText ref={ref} onClick={props.onClick} {...props}>
      {props.children}
    </StyledText>
  );
});

export default Text;
